import type { Id } from '@e-socna/data-layer';

type SnapshotGroup = Readonly<{ subMissionId?: Id | null }>;

export type SubMissionSnapshotSection<G> = Readonly<{
  subMissionId: Id;
  groups: readonly G[];
}>;

// The snapshot of a collaboration lists the groups of each sub-mission (in
// the order of the quotation), then its own groups.
export const splitSnapshotGroupsBySubMission = <G extends SnapshotGroup>(
  groups: readonly G[],
): Readonly<{
  subMissionSections: readonly SubMissionSnapshotSection<G>[];
  ownGroups: readonly G[];
}> => {
  const subMissionIds = [
    ...new Set(
      groups
        .map(({ subMissionId }) => subMissionId)
        .filter((subMissionId): subMissionId is Id => !!subMissionId),
    ),
  ];

  return {
    subMissionSections: subMissionIds.map((subMissionId) => ({
      subMissionId,
      groups: groups.filter((group) => group.subMissionId === subMissionId),
    })),
    ownGroups: groups.filter(({ subMissionId }) => !subMissionId),
  };
};
